module.exports = __webpack_public_path__ + "static/media/menu-architect.4d6145ff.png";